<button
  mat-icon-button
  aria-label="Sociétés"
  matTooltip="Sociétés"
  #trigger="matMenuTrigger"
  [matMenuTriggerFor]="jobMenu"
>
  <svg lucideBuilding2 class="vanex-gold"></svg>
</button>

<mat-menu #jobMenu="matMenu">
  @for (company of companies$ | async; track company.id) {
    <button mat-menu-item (click)="openCompanyDialog(company)">
      @let hasLogo = companyLogos.has(company.id);
      <app-company-picture-color
        [class.stroke]="!hasLogo"
        [company]="company"
        [tooltip]="!hasLogo ? 'Logo absent' : ''"
      ></app-company-picture-color>
      <span> {{ company.name }} </span>
      @if (stateLabel(company); as label) {
        <span class="company-state">— {{ label }}</span>
      }
    </button>
  }
</mat-menu>
